export default "__VITE_ASSET__By_b_FPg__"